export function trackEvent(event_name, context) {
    if (Shopify.analytics) {
        Shopify.analytics.publish(event_name, context);
    }
}
